'use client';

import { TRACKED_EVENT_NAME, TRACKED_EVENT_POSITION } from '@/constants';
import { validateGtag } from '@/utils';
import { useLocale } from 'next-intl';
import { useCallback } from 'react';

export function Mail({ email }: { email: string }) {
  const locale = useLocale();

  const onMailClick = useCallback(() => {
    if (!validateGtag()) return;

    window.gtag('event', TRACKED_EVENT_NAME.CLICK_MAIL, {
      event_label: email,
      position: TRACKED_EVENT_POSITION.FOOTER,
      user_language: locale,
    });
  }, [email, locale]);

  return (
    <a
      href={`mailto:${email}`}
      onClick={onMailClick}
      className="hover:underline"
    >
      {email}
    </a>
  );
}
